import React, { useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Global from "../../util/Global";
import moment from 'moment';
import { useTranslation } from "react-i18next";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
import { LoaderComponent } from "../../util/Loader";
import NotFound from "../../components/NotFound";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, IconButton } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import Pagination from "../../components/Pagination";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { SortTabCell } from "../../components/Utils";

const AdminContact = () => {

  const { t } = useTranslation();
  const [listMessage, setListMessage] = useState([]);
  const [paginatedItems, setpaginatedItems] = useState([])
  const [isLoading, setisLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredMessages, setFilteredMessages] = useState(listMessage);
  const [sortDirection, setSortDirection] = useState('desc');
  const [sortColumn, setSortColumn] = useState('date');
  const [sortedItems, setsortedItems] = useState([])

  const navigate = useNavigate()


  const MES_MESSAGE_URL = Global.backend + "/index.php/api/contact/list";



  const { setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)

  useEffect(() => {
    setpageNavLink({ path: "/dashboard/admin", label: "adminDashboard" })
    setpageTitle("inbox")
    setalertTitle("")
    setnavLinks([])
  }, [])




  useEffect(() => {
    setisLoading(true)
    axios
      .get(MES_MESSAGE_URL)
      .then((response) => {
        setListMessage(response.data);
      })
      .finally(() => {
        setisLoading(false);
      });
  }, []);






  useEffect(() => {
    setFilteredMessages(
      listMessage.filter(message =>
        message.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
        message.subject.toLowerCase().includes(searchTerm.toLowerCase()) ||
        message.body.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, listMessage]);

  useEffect(() => {
    const sortedMessages = [...filteredMessages].sort((a, b) => {
      if (sortDirection === 'asc') {
        return a[sortColumn] > b[sortColumn] ? 1 : -1;
      } else {
        return a[sortColumn] < b[sortColumn] ? 1 : -1;
      }
    });
    setsortedItems(sortedMessages)
  }, [sortDirection, sortColumn, filteredMessages]);

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortDirection('asc');
    }
  };





  return (
    <LoaderComponent isLoading={isLoading}>
      {!isLoading && (
        !listMessage.length ? <NotFound /> :
          <div className="container-fluid">
            <div className="row">
              <div className="card">
                <div className="card-body">
                  <TextField
                    label="Search"
                    variant="outlined"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <IconButton>
                          <SearchIcon />
                        </IconButton>
                      ),
                    }}
                    fullWidth
                    margin="normal"
                  />


                  {!paginatedItems.length ? <NotFound /> :
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <SortTabCell title={t("user.mail")} label={"email"} sortColumn={sortColumn} sortDirection={sortDirection} onClick={handleSort} />
                            <SortTabCell title={t("subject")} label={"subject"} sortColumn={sortColumn} sortDirection={sortDirection} onClick={handleSort} />
                            <SortTabCell title={t("date")} label={"date"} sortColumn={sortColumn} sortDirection={sortDirection} onClick={handleSort} />
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {paginatedItems.map((message, index) => (
                            <TableRow
                              key={index}
                              hover
                              onClick={() => navigate(`/dashboard/admin/detailcontact/${message.id}/${encodeURIComponent(JSON.stringify(message))}`)}
                              style={{ cursor: 'pointer' }}
                            >
                              <TableCell>
                                <div className="d-flex align-items-center">
                                  <IconButton size="small">
                                    {message.readed ? <CheckCircleIcon /> : <CheckCircleOutlineIcon />}
                                  </IconButton>
                                  {message.email ? message.email : t("anonymous")}
                                </div>
                              </TableCell>
                              <TableCell>
                                {message.subject} <span className="teaser">{message.body}</span>
                              </TableCell>
                              <TableCell>{moment(message.date).format('MMMM D, YYYY')} ({moment(message.date).fromNow()})</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  }
                  <Pagination itemsPerPage={10} items={sortedItems} setItems={setpaginatedItems} />
                </div>
              </div>
            </div>
          </div>
      )
      }
    </LoaderComponent>
  );
};

export default AdminContact;